import React from "react";
import { PropTypes } from "prop-types";
import { connect } from "react-redux";
import { updateActivePageStepName, step1Edit } from "../actions";
import {
  updateActivePageStepNumber,
  updatePageStepToProcess,
  updateStepperIndex,
  updateStepperAllToFinish
} from "../../../../actions/globalActions";
import { HeadMedium, HeadWrap, PillButtonEdit, EditIcon } from "./styles";
import editIcon from "../../../../assets/icons/edit.svg";
import PrimaryInfo from "./Components/PrimaryAdvisorInfo";
import SecondaryInfo from "./Components/SecondaryAdvisorInfo";
import { DividerWrap } from "./Components/Details/styles";
import { Divider } from "antd";
import LegacyOptions from "./Components/LegacyOptions/LegacyOptions";
import history from "../../../../history/history";
import RelatedContributor from "./Components/RelatedContributor";
import { initiateTracking, recordError } from "../../../../utils/commonUtil";
import { basicTempData, basicStepperConfig } from '../DefaultPropTypes';
import { CapsuleButton } from "../../../../CommonComponents/Commons/commonComponents";
import { MainPageDerivedStates } from "../selectors";

export class MainPage extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      stepper : [
        {
          key: 1,
          description: "Provide account information",
          status: "",
          route: "/open-an-additional-account/account-information/",
          pageName: "step1Setup"
        },
        {
          key: 2,
          description: "Legacy options",
          status: "",
          route: "/open-an-additional-account/legacy-options/",
          pageName: "step2Legacy"
        },
        {
          key: 3,
          description: "Review and Submit",
          status: "",
          route: "/open-an-additional-account/review/",
          pageName: "step3Review"
        }
      ]
    }
  }
  componentWillMount() {
    this.props.setActivePageStepNumber(3);
    this.props.setActivePageStepName("step3Review");
    this.props.updateStepperAllToFinish([
      {
        key: 1,
        description: "Provide account information",
        status: "finish",
        route: "/open-an-additional-account/account-information/",
        pageName: "step1Setup"
      },
      {
        key: 2,
        description: "Legacy options",
        status: "finish",
        route: "/open-an-additional-account/legacy-options/",
        pageName: "step2Legacy"
      },
      {
        key: 3,
        description: "Review and Submit",
        status: "process",
        route: "/open-an-additional-account/review/",
        pageName: "step3Review"
      }
    ]);
  }

  handleEdit = () => {
    try {
      initiateTracking('edit', 'Open Additional Account', 'Step 3 Review and Submit - Personal Information', 'Edit - Body')
      this.props.updateStepperIndex({
        status: true,
        index: 1
      });
  
      let tempCheckBoxStatus = {};
  
      if(this.props.tempCheckBoxStatus.addressChecked){
        tempCheckBoxStatus = this.props.tempCheckBoxStatus;
      }else{
        tempCheckBoxStatus = this.props.tempData[2];
      }
  
      let stepperConfig = [...this.state.stepper];
      stepperConfig[0].status = "process";
      stepperConfig[1].status = "wait";
      stepperConfig[2].status = "wait";
  
      if(tempCheckBoxStatus != undefined){
        this.props.updateStepperAllToFinish(stepperConfig);
        history.push({
          pathname: '/open-an-additional-account/account-information/',
          state: { tempCheckBoxStatus }
        })
      }else{
        this.props.updateStepperAllToFinish(stepperConfig);
        history.push("/open-an-additional-account/account-information/");
      }
      window.scrollTo(0, 0);
    } catch (error) {
      recordError(error);
    }
  };

  render() {
    return (
      <div>
        <HeadWrap>
          <HeadMedium>Personal Information</HeadMedium>
          <CapsuleButton 
            whiteBackground = {true}
            text = "Edit"
            iconType = "edit"
            onClick={this.handleEdit}
          />
        </HeadWrap>
        <PrimaryInfo />
        {this.props.tempData[1] && this.props.tempData[1].firstname !== null ? <SecondaryInfo /> : null}
        <RelatedContributor />
        <DividerWrap margin="unique">
          <Divider />
        </DividerWrap>
        <LegacyOptions  contentType={"sub_headings_desc_legacy_options"} page={'Legacy options'} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...MainPageDerivedStates(state.toJS()),
  tempData: state.getIn(["npaFormReducer", "tempJSON", "tempJSON", "tempJSON","advisors"])
});

const mapDispatchToProps = dispatch => ({
  setActivePageStepNumber: stepNumber =>
    dispatch(updateActivePageStepNumber(stepNumber)),
  setActivePageStepName: stepName =>
    dispatch(updateActivePageStepName(stepName)),
  processActivePageStep: () => dispatch(updatePageStepToProcess()),
  step1Edit: val => dispatch(step1Edit(val)),
  updateStepperIndex: data => dispatch(updateStepperIndex(data)),
  updateStepperAllToFinish: data => dispatch(updateStepperAllToFinish(data))
});

MainPage.propTypes = {
  activePageStepNumber: PropTypes.number,
  isSecondary: PropTypes.any,
  processActivePageStep: PropTypes.func,
  setActivePageStepName: PropTypes.func,
  setActivePageStepNumber: PropTypes.func,
  step1Edit: PropTypes.func,
  stepperConfig: basicStepperConfig,
  tempCheckBoxStatus: PropTypes.any,
  tempData: basicTempData,
  updateStepperAllToFinish: PropTypes.func,
  updateStepperIndex: PropTypes.func,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPage);
